import Vue from 'vue'
import Vuex from 'vuex'

import { PAGE_TITLE, PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from './mutation-types';
import auth from './modules/auth';
import transactionList from './modules/transaction/list';
import stockList from './modules/stock/list';
import courierList from './modules/courier/list';
import profileList from './modules/setting/list';
import dashboardList from './modules/dashboard/list'
import getEwallet from './modules/ewallet/listEwallet';
import maps from './modules/setting/maps'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        pageTitle: 'Stockist Mobile Counter',
        progressStatus: '',
    },
    mutations: {
        [PAGE_TITLE](state, title) {
            state.pageTitle = title;
        },

        [PROGRESS_START](state) {
            state.progressStatus = 'start';
        },

        [PROGRESS_FINISH](state) {
            state.progressStatus = 'finish';
        },

        [PROGRESS_FAIL](state) {
            state.progressStatus = 'fail';
        },
    },
    actions: {
        setPageTitle({ commit }, title) {
            commit(PAGE_TITLE, title);
        },
    },
    modules: {
        auth,
        transactionList,
        stockList,
        courierList,
        profileList,
        dashboardList,
        getEwallet,
        maps,
    }
})